<template>
    <a-row type="flex" class="item">
        <a-col>
            <span class="label">{{ label }}</span><br/>
            <span class="content">
                <slot v-if="has"></slot>
                <span v-else>{{ comment }}</span>
            </span>
        </a-col>
        <a-col class="action">
            <slot name="action"></slot>
        </a-col>
    </a-row>
</template>

<script>
export default {
    props: [ 'label', 'comment', 'has' ],
}
</script>

<style lang="less" scoped>
.item {
    padding: 10px;
}
.action {
    margin-left: auto;
}
.label {
    font-size: 16px;
}
.content {
    color: rgba(0, 0, 0, 0.45);
}
</style>